import allActions from "../../../../actions";

//Regras de contato compartilhadas pelas abas de Cadastros > Marketing. Todas partem
//do mesmo getClientsContacts e geram as mesmas linhas por destinatário; o que muda
//entre as abas é só o recorte de clientes e as colunas próprias de cada uma.

//Tipos de destinatário oferecidos no filtro. O role_type casa com o que
//getClientsContacts devolve; INSTITUTIONAL não vem de users, é o e-mail do cliente.
export const RECIPIENT_TYPES = [
    { key: 'INSTITUTIONAL', label: 'Institucional' },
    { key: 'MANAGER', label: 'Gestor', roleType: 'ROLE_MANAGER' },
    { key: 'SUBMANAGER', label: 'Subgestor', roleType: 'ROLE_SUBMANAGER' },
];

export const ALL_RECIPIENT_TYPE_KEYS = RECIPIENT_TYPES.map(el => el.key);

const ROLE_TYPE_TO_KEY = {
    'ROLE_MANAGER': 'MANAGER',
    'ROLE_SUBMANAGER': 'SUBMANAGER',
};

const LABEL_BY_KEY = RECIPIENT_TYPES.reduce((acc, el) => {
    acc[el.key] = el.label;
    return acc;
}, {});

const NO_MANAGER_LABEL = 'SEM GESTOR ATIVO';

//Um mesmo campo de e-mail guarda, em cerca de 12% dos clientes, vários endereços,
//com separador inconsistente: ';', ',', ' / ', espaço, às vezes ';' sobrando no fim.
//Sem separar, a contagem de únicos mente e a string colada no Gmail sai malformada.
//Descarta pedaços sem '@' (restos de digitação).
export function splitEmails(field) {
    if (!field) return [];

    return String(field)
        .split(/[;,/\s]+/)
        .map(el => el.trim())
        .filter(el => el.indexOf('@') > 0);
}

//Remove repetições preservando a ordem de aparição. O e-mail institucional às vezes
//é igual ao de um gestor, então o disparo precisa da lista deduplicada.
export function uniqueEmails(rows) {
    const seen = new Set();
    const list = [];

    rows.forEach(row => {
        if (!row.email) return;

        const key = row.email.trim().toLowerCase();
        if (!key || seen.has(key)) return;

        seen.add(key);
        list.push(row.email.trim());
    });

    return list;
}

//Contatos agrupados por cliente. Clientes sem gestor ativo vêm do backend com
//user_id nulo, então terminam aqui com users vazio: é o que se quer sinalizar.
//list preserva a ordem alfabética do SQL (um objeto com chave numérica reordenaria
//por id); byId serve a quem parte de outra lista de clientes.
export function groupContactsByClient(contactsArray) {

    const byId = {};
    const list = [];

    (contactsArray || []).forEach(row => {
        if (!byId[row.client_id]) {
            byId[row.client_id] = {
                client_id: row.client_id,
                label_name: row.label_name,
                institutional_email: row.institutional_email,
                last_suitability_date: row.last_suitability_date,
                last_suitability_result: row.last_suitability_result,
                users: [],
            };
            list.push(byId[row.client_id]);
        }

        if (row.user_id && ROLE_TYPE_TO_KEY[row.role_type]) {
            byId[row.client_id].users.push(row);
        }
    });

    return { byId, list };
}

//Linhas de destinatário de um cliente: institucional, gestores e subgestores, cada
//uma com os campos de baseRow. wantsType(key) diz se o tipo passou pelo filtro.
export function buildContactRows(baseRow, contact, wantsType) {

    const rows = [];

    if (wantsType('INSTITUTIONAL')) {
        splitEmails(contact.institutional_email).forEach(email => rows.push({
            ...baseRow,
            tipo: LABEL_BY_KEY.INSTITUTIONAL,
            nome: '',
            email,
        }));
    }

    //Conta gestores que passaram pelo filtro de tipo, e não linhas: um gestor com
    //e-mail imprestável gera zero linhas, mas ainda assim existe e não deve
    //disparar o aviso de "sem gestor".
    let matchedUsersCount = 0;

    contact.users.forEach(user => {
        const typeKey = ROLE_TYPE_TO_KEY[user.role_type];
        if (!wantsType(typeKey)) return;

        matchedUsersCount++;

        const userEmails = splitEmails(user.user_email);

        //Sem e-mail aproveitável a linha fica na tela com a célula vazia: o gestor
        //existe e o cadastro é que precisa de conserto.
        if (!userEmails.length) userEmails.push('');

        userEmails.forEach(email => rows.push({
            ...baseRow,
            tipo: LABEL_BY_KEY[typeKey],
            nome: user.user_name,
            email,
        }));
    });

    //Cliente sem ninguém para contatar além do institucional: a linha fica na
    //tela e na planilha (com e-mail vazio) para o gap ficar visível, mas nunca
    //entra na string copiada, que só considera linhas com e-mail.
    const wantsAnyManager = wantsType('MANAGER') || wantsType('SUBMANAGER');
    if (wantsAnyManager && matchedUsersCount === 0) {
        rows.push({
            ...baseRow,
            tipo: NO_MANAGER_LABEL,
            nome: '',
            email: '',
        });
    }

    return rows;
}

export function copyEmailsToClipboard(emails, separator, dispatch) {

    if (!emails.length) {
        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            message: 'Nenhum e-mail para copiar',
            type: 'warning',
        }));
        return;
    }

    navigator.clipboard.writeText(emails.join(separator + ' '));

    dispatch(allActions.mainAlertActions.setMainAlert({
        show: true,
        message: emails.length + ' e-mails copiados para a área de transferência!',
        type: 'success',
    }));
}
